<template>
  <reference-filter-multiple-select
    label="Screening Status"
    :options="options"
    :selected-values.sync="selectedModel"
  />
</template>

<script>
import ReferenceFilterMultipleSelect from './ReferenceFilterMultipleSelect';
import { AssessmentStatusFilter } from '@/enums';

const ASSESSMENT_STATUS_FILTER_TO_OPTION = {
  [AssessmentStatusFilter.NO_ASSESSMENTS]: 'No votes',
  [AssessmentStatusFilter.AWAITING_ONE_ASSESSMENT]: 'Awaiting a vote',
  [AssessmentStatusFilter.AWAITING_ONE_ASSESSMENT_BY_YOU]:
    'Awaiting a vote by you',
  [AssessmentStatusFilter.ASSESSMENTS_BY_YOU]: 'Votes by you',
  [AssessmentStatusFilter.RELEVANT_ASSESSMENT_BY_YOU]:
    'Relevant vote by you',
  [AssessmentStatusFilter.NOT_SURE_ASSESSMENT_BY_YOU]:
    'Not Sure vote by you',
  [AssessmentStatusFilter.NOT_RELEVANT_ASSESSMENT_BY_YOU]:
    'Not Relevant vote by you',
  [AssessmentStatusFilter.CONFLICTED]: 'Conflicted',
  [AssessmentStatusFilter.RELEVANT_OUTCOME]: 'Included',
  [AssessmentStatusFilter.NOT_SURE_OUTCOME]: 'Not Sure',
  [AssessmentStatusFilter.NOT_RELEVANT_OUTCOME]: 'Excluded',
};

export default {
  name: 'ReferenceFilterScreeningStatus',
  components: { ReferenceFilterMultipleSelect },
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:selected'],
  computed: {
    selectedModel: {
      get() {
        return this.selected;
      },
      set(value) {
        this.$emit('update:selected', value);
      },
    },
    options() {
      return Object.keys(ASSESSMENT_STATUS_FILTER_TO_OPTION).map(
        (filter) => ({
          value: filter,
          label: ASSESSMENT_STATUS_FILTER_TO_OPTION[filter],
        })
      );
    },
  },
};
</script>
